import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/solid';
import { useEffect, useState } from 'react';
import { fetchPartnerships } from '../providers/partnerships';
import { useTranslations } from '../providers/i18n';

function SortPartnerships(props) {
    const [t, translationsLoaded] = useTranslations('admin');
    const [ready, setReady] = useState(false);
    const [partnerships, setPartnerships] = useState([]);

    const swapPartnerships = (a, b) => {
        setPartnerships((oldValue) => {
            const newValue = [...oldValue];
            const temp = newValue[a];
            newValue[a] = newValue[b];
            newValue[b] = temp;
            return newValue;
        });
    };

    useEffect(() => {
        fetchPartnerships().then((partnerships) => {
            setPartnerships(partnerships);
            setReady(true);
        });
    }, []);

    if (!ready) return null;
    if (!translationsLoaded) return null;

    return (
        <div className="space-y-2">
            {partnerships.length ? (
                <div className="overflow-hidden rounded-md border border-gray-300 shadow-sm">
                    <table className="w-full">
                        <thead className="bg-gray-50">
                            <tr>
                                <th colSpan="2" className="px-4 py-2 text-left font-medium">
                                    {t('models.partnerships')}
                                </th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody className="divide-y bg-white">
                            {partnerships.map(({ id, name }, index) => (
                                <tr key={index}>
                                    <td className="w-0 py-2 pl-4">
                                        <div className="flex gap-1">
                                            <button
                                                type="button"
                                                className={`text-gray-500 hover:text-gray-800 ${index == 0 ? 'opacity-0' : ''}`}
                                                onClick={() => {
                                                    swapPartnerships(index, index - 1);
                                                }}
                                            >
                                                <ChevronUpIcon className="relative top-[1px] h-5 w-5" />
                                            </button>

                                            <button
                                                type="button"
                                                className={`text-gray-500 hover:text-gray-800 ${index == partnerships.length - 1 ? 'opacity-0' : ''}`}
                                                onClick={() => {
                                                    swapPartnerships(index, index + 1);
                                                }}
                                            >
                                                <ChevronDownIcon className="relative top-[1px] h-5 w-5" />
                                            </button>
                                        </div>
                                    </td>
                                    <td className="px-4 py-2">{name}</td>
                                    <td className="w-0 text-right text-xs">
                                        <input type="hidden" name="partnerships[]" value={id} />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            ) : (
                <>
                    <input type="hidden" name="clinics[]" />
                    <div className="mb-4 rounded-md border-2 border-dashed border-gray-300 py-10 text-center text-gray-500">{t('no-clinics')}</div>
                </>
            )}
        </div>
    );
}

export default SortPartnerships;
